import { IMappers } from '../../../../common/repositories/price-estimator/suburban/v1/create-realty';
import { ICreateSuburbanRealtyResponse } from '../../../../common/repositories/price-estimator/entities/web/CreateSuburbanRealtyResponse';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

export const createSubmitSuburbanDataMapper = (): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response.dataPaymentFormUrl,
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: '',
      statusCode: 400,
      message: message || '',
    });
  },
});

export type TMappedResponse200 = ICreateSuburbanRealtyResponse['dataPaymentFormUrl'];
export type TMappedResponse400 = HttpBadStatusCodeError;
